import {App} from "@/apps/FavoriteAppsWidget/models/app-viewmodel";

export const sortAppByTitle = function (arr: App[]) {
    if (!Array.isArray(arr)) {
        return []
    }
    return arr.sort((a,b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0));
}
